var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExperts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440.5 556Q378 556 334 511.938 290 467.875 290 406q0-63 44.062-106.5Q378.125 256 440 256q63 0 106.5 43.5t43.5 106q0 62.5-43.5 106.5t-106 44zm-.5-60q38 0 64-26.438 26-26.437 26-63.562 0-38-26-64t-63.5-26q-37.5 0-64 26T350 405.5q0 37.5 26.438 64Q402.875 496 440 496zm458 540L758 896q-23 17-47.5 23.5t-50.065 6.5q-71.015 0-120.725-49.618Q490 826.765 490 755.882 490 685 539.618 635.5q49.617-49.5 120.5-49.5Q731 586 780.5 635.71T830 756.435q0 25.565-6.5 50.065Q817 831 800 854l140 140-42 42zM660 866q47 0 78.5-31.5T770 756q0-47-31.5-78.5T660 646q-47 0-78.5 31.5T550 756q0 47 31.5 78.5T660 866zm-540 30v-94q0-37 17.5-63t50.5-43q47-23 122.5-43.5T464 637q-8 13-15 28.5T438 696q-78-1-136 18.5T212 750q-14 8-23 21.5t-9 30.5v34h258q11 17 20 31.5t20 28.5H120zm320-490zm-2 430z"
  })));
}

export default SvgExperts;